import { render, staticRenderFns } from "./CustomerViewTicket.vue?vue&type=template&id=770755c9&scoped=true"
import script from "./CustomerViewTicket.vue?vue&type=script&lang=js"
export * from "./CustomerViewTicket.vue?vue&type=script&lang=js"
import style0 from "./CustomerViewTicket.vue?vue&type=style&index=0&id=770755c9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "770755c9",
  null
  
)

export default component.exports